export default {"src":"/_next/static/media/menu-icon.7d5550b2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};